import React from 'react';
import { Alert } from 'react-bootstrap';
import { isSchoolLaboratory, schoolClaimsFromUser } from './schoolClaims.ts';

type Props = {
  user: { schoolClaims?: { laboratory?: boolean; schoolName?: string; roles?: string[] } } | null;
};

export default function SchoolLabBanner({ user }: Props) {
  if (!isSchoolLaboratory(user)) return null;
  const claims = schoolClaimsFromUser(user);
  const schoolName = claims.schoolName || 'Solbakken laboratory';
  const role = Array.isArray(claims.roles) && claims.roles[0] ? claims.roles[0].replace(/-/g, ' ') : 'lab account';

  return (
    <Alert variant="warning" className="mb-0 rounded-0">
      <strong>Solbakken laboratory — not a real school.</strong>
      {' '}
      Signed in as {role} at {schoolName}.       Teachers cannot browse classmate chat.
      Classmate messages use pupil thread keys plus a laboratory school safety key — not end-to-end against the municipality processor.
      The mascot is local to classmate compose. Yellow/red is a phrase-list stub, not a pilot.
    </Alert>
  );
}
